import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-dropdown', 'openLang', 'Open language select');
Labels.set('ui-dropdown', 'countryCode', 'Country code');
Labels.set('ui-dropdown', 'listboxName', 'Available options');

Labels.set('ui-dropdown', 'eng', 'English');
Labels.set('ui-dropdown', 'est', 'Estonian');
Labels.set('ui-dropdown', 'lat', 'Latvian');
Labels.set('ui-dropdown', 'lit', 'Lithuanian');
Labels.set('ui-dropdown', 'rus', 'Russian');
